import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import AdminStats from './AdminStats';
import UserManagement from './UserManagement';
import SellerVerification from './SellerVerification';

const AdminDashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'stats');

  useEffect(() => {
    const tab = searchParams.get('tab') || 'stats';
    setActiveTab(tab);
  }, [searchParams]);

  const handleTabChange = (value) => {
    setActiveTab(value);
    setSearchParams({ tab: value });
  };

  return (
    <AdminLayout activeTab={activeTab} onTabChange={handleTabChange}>
      <AdminStats />
      <UserManagement />
      <SellerVerification />
    </AdminLayout>
  );
};

export default AdminDashboard;